
import { Container } from "inversify";

const ServiceContainer = new Container();

export { ServiceContainer as IoC }